import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { LinkCard } from "../../LinkCard/LinkCard";
import "../HeroV2.global.scss";
import styles from "./HeroCards.module.scss";
export const HeroCards = ({ cards }) => {
    const handleHeroCardClick = useCallback((label) => {
        dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, { cta_name: label, cta_location: "hero-card" });
    }, [dispatchTrackingEvent]);
    return (_jsx("div", { className: `${styles.heroCardsContainer} grid-container card-container`, children: _jsx("div", { className: styles.heroCards, "data-testid": "hero-cards-container", children: cards.map((card, index) => (_jsx(LinkCard, { dataTestId: `${card.label}--${index}`, onClick: handleHeroCardClick, ...card }, `${card.label}--${index}`))) }) }));
};
//# sourceMappingURL=HeroCards.js.map